module.exports = __webpack_public_path__ + "img/fe_backdrop_emblem_spartan_edition.b8efb942.png";